import {
  DESTROY_TILING,
  START,
  SUCCESS,
  FAIL,
  CREATE_TILING,
  SET_TILE_PADDING
} from "../constants/action-types";
import Mediator from "../services/Mediator";

export const destroyTiling = () => (dispatch) => {
  try {
    Mediator.destroyTilingFromActiveObject();
    dispatch({
      type: DESTROY_TILING
    });
  } catch (error) {
    throw error;
  }
};

export const createTiling = (typeOfTiling) => async (dispatch) => {
  try {
    dispatch({
      type: CREATE_TILING + START
    });
    await Mediator.createTilingFromActiveObject(typeOfTiling);
    dispatch({
      type: CREATE_TILING + SUCCESS
    });
  } catch (error) {
    dispatch({
      type: CREATE_TILING + FAIL,
      error
    });
    throw error;
  }
};

export const setTilePadding = (value) => (dispatch) => {
  dispatch({
    type: SET_TILE_PADDING,
    payload: {
      value
    }
  });
  Mediator.setTilePaddingToActive(value);
};
